import React from 'react';
import './index.css';
import util from "../../util/tools";
import Toast from '../common/Toast'

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fee: this.props.match.params.fee,
            text: "",
            imgs: []
        };

        this.getInfoFun = this.getInfoFun.bind(this);
        this.backFun = this.backFun.bind(this);
        this.recharge = this.recharge.bind(this);
        this.showText = this.showText.bind(this);
    }

    componentDidMount() {
        document.title = '充值赠送(商品详情)'
        this.getInfoFun();
    }

    getInfoFun(){
        util.ajax({
            // host: "http://open.fangkuai8.com",
            url: "/zh/sendgift/goodslists",
            // app_key: "6821674987",
            // app_secret: "55f3b0e685b97de7e9c47ab3cd940vdn",
            data: {
                fee: this.state.fee
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        imgs: res.result.data
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(jump){
        let url = this.state.weixinurl || `${document.location.href}`
        if(!!jump){
            url = document.location.origin + "/wuliulist";
        }
        let params = {
            'total_fee':this.state.fee,
            'back_url':url,
            'error_url':document.location.origin + "/recharge",
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    backFun(){
        try{
            window.history.back();
        }catch(e){}
    }

    render() {
        return (
            <div className='libaopage'>
                {
                    this.state.imgs.map((item,index)=>(
                        <img  src={item} key={`img${index}`} />
                    ))
                }
                <div className="backBtn" onClick={this.backFun}>返回</div>
                <div className={`payBtn fee${this.state.fee}`} onClick={()=>this.recharge(1)}>充值</div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}